const PLACEHOLDER_PHRASES = new Set([
  'asd',
  'asdf',
  'asdfasdf',
  'lorem',
  'lorem ipsum',
  'test',
  'test test',
  'testing',
  'xxx',
  'zzz',
  'qwerty',
  '123',
  '123123',
  '123456',
]);

const WORD_PATTERN = /[A-Za-zÀ-ž0-9]+(?:[-/][A-Za-zÀ-ž0-9]+)*/g;

export const isProjectDescriptionMeaningful = (value: string) => {
  const normalized = value.trim().toLowerCase();
  if (!normalized) {
    return false;
  }

  if (PLACEHOLDER_PHRASES.has(normalized)) {
    return false;
  }

  const words = normalized.match(WORD_PATTERN) || [];
  const uniqueWords = new Set(words);
  const longWords = words.filter(word => word.length >= 4);
  const lettersOnly = normalized.replace(/[^A-Za-zÀ-ž]/g, '');
  const nonWhitespace = normalized.replace(/\s/g, '');
  const alphaRatio = nonWhitespace.length ? lettersOnly.length / nonWhitespace.length : 0;

  if (/(.)\1{4,}/.test(normalized)) {
    return false;
  }

  if (words.length < 6) {
    return false;
  }

  if (uniqueWords.size < 4) {
    return false;
  }

  if (longWords.length < 3) {
    return false;
  }

  if (lettersOnly.length < 20) {
    return false;
  }

  if (alphaRatio < 0.55) {
    return false;
  }

  return true;
};
